import { Box, TableRow, Tabs } from "@mui/material";
import { styled } from "@mui/system";
import theme from "../../theme";
import { CustomButton } from "../../common/components/functional/customButton/CustomButton";

const ActionButton = styled(CustomButton)(() => ({
  textTransform: "none",
  borderRadius: "20px",
}));

const Body = styled(Box)(() => ({
  "&.MuiBox-root": {
    textAlign: "left",
  },
  "&.MuiBox-root > .MuiBox-root:first-of-type": {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
  },
}));

const StripedRows = styled(TableRow)(() => ({
  ":nth-of-type(even)": { backgroundColor: "#ffffff" },
  ":nth-of-type(odd)": { backgroundColor: "#f9f9f9" },
}));

const StyledTabs = styled(Tabs)(() => ({
  borderBottom: "1px solid #4A1D9C1F",
  "& .MuiTab-root": {
    textTransform: "none",
    fontWeight: 700,
    "&.Mui-selected": {
      "& span": {
        color: theme.palette.primary.main,
      },
    },
  },
}));

export { ActionButton, Body, StripedRows, StyledTabs };
